<template>
  <div class="monthlist">
    <div class="comp-full-calendardiy">
      <div class="month-title">
        <div class="title">
          <div>
            <i class="el-icon-date" @click="displayleft"></i>
            <span>月视图</span>
          </div>
          <div class="">
            <el-switch
              class="nav-rt-sw"
              v-model="switchVal"
              :width="33"
              active-color="#13ce66"
              inactive-color="#bbbbbc"
              @change="switchChang"
            >
            </el-switch>
            <span>显示已完成</span>
          </div>
        </div>
        <div class="time">
          <span>{{ title }}</span>
        </div>
      </div>
      <div class="header-center">
        <div class="btn up" @click="goPrev"><i class="el-icon-back"></i></div>
        <div class="btn down" @click="goNext">
          <i class="el-icon-right"></i>
        </div>
        <!-- <fc-body
          :current-date="headDate"
          :events="events"
          :month-names="monthNames"
          ref="fcbody"
          :loading="loading"
          :first-day="firstDay"
          :weekDays="weekDays"
          :switchVal="switchVal"
        >
        </fc-body> -->
        <full-calendar
          :switchVal="switchVal"
          :events="newEvens"
          :first-day="firstDay"
          lang="zh"
          @eventClick="eventClick"
          @dayClick="dayClick"
        ></full-calendar>
      </div>
    </div>
    <!-- 左侧边栏 -->
    <el-drawer
      :visible.sync="drawer"
      :with-header="false"
      direction="ltr"
      size="288px"
    >
      <left-nav></left-nav>
    </el-drawer>

    <el-drawer
      :visible.sync="drawerrt"
      :with-header="false"
      size="288px"
      :modal="false"
    >
      <rels-right
        :options="options"
        :value1="rightTime"
        :value2="rightTime1"
        @weekapi="weekapi"
      ></rels-right>
    </el-drawer>
  </div>
</template>
<script type="text/babel">
import FullCalendar from "../../assets/vue-fullcalendar/fullCalendar";
import dateFunc from "../../util/dateFunc";
import bus from "./../../util/bus";
import leftNav from "../../components/content/leftNav";
// import fcBody from "../../components/vue-fullcalendar/body";
import relsRight from "../../components/content/release.vue";
export default {
  components: {
    // "fc-body": fcBody,
    leftNav,
    FullCalendar,
    relsRight,
  },

  data() {
    return {
      fcEvents: [],
      interviewEvent: {},
      monms: "",

      //top
      title: "",
      headDate: new Date(),
      titleFormat: "yyyy/MM",
      monthNames: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
      ],

      events: [],
      weekDays: [],
      switchVal: false,
      drawer: false,

      newEvens: [],
      drawerrt: false,

      options: {},
      rightTime: "",
      rightTime1:""
    };
  },
  props: {
    firstDay: {
      type: Number | String,
      validator(val) {
        let res = parseInt(val);
        return res >= 0 && res <= 6;
      },
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  watch: {},

  created() {
    this.dispatchEvent();
    this.fetchEventsList();
    bus.$on("release", () => {
      this.fetchEventsList();
    });
  },
  methods: {
    // 点击日历的清单数据
    eventClick(e) {
      console.log(e, "点击某个清单出现");
      this.drawerrt = true;
      let obj = {
        ...e,
        btnText: "修改",
      };
      this.rightTime = e.task_time;
      this.rightTime1 = e.task_endtime
      this.options = obj;
    },

    // 点击的清单
    dayClick(e) {
      console.log(e, "点击日历某一天");
      let obj = {
        btnText: "发布",
      };
      this.options = obj;
      this.rightTime =
        e.getFullYear() + "-" + (e.getMonth() + 1) + "-" + e.getDate();
      this.rightTime1 = e.getFullYear() + "-" + (e.getMonth() + 1) + "-" + e.getDate();
      console.log(this.rightTime);
      this.drawerrt = true;
    },

    // 点击清单按钮
    weekapi() {
      this.drawerrt = false;
      this.options = {};
      this.rightTime = "";
      this.rightTime1 = ""
    },

    //左边显示
    displayleft() {
      if (document.body.clientWidth <= 1200) {
        this.drawer = true;
      }
    },

    //获取数据
    fetchEventsList() {
      console.log(this.headDate);
      let data =
        this.headDate.getFullYear() + "-" + (this.headDate.getMonth() + 1);
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .monthday(data, header)
        .then((res) => {
          console.log(res, "获取的数据");
          let data = res.data.result;

          data.forEach((item,index) => {
            item.title = item.task_name;
            item.start = item.task_time;
            // item.end = item.task_endtime;
            item.cssClass =
              item.type == 0
                ? "rgba(236, 114, 89,.7)"
                : item.type == 1
                ? "rgba(246, 168, 1,.7)"
                : item.type == 2
                ? "rgba(183, 142, 252,.7)"
                : "rgba(144, 208, 52,.7)";
          });

          this.events = data;
          this.newEvens = data;
          console.log(this.newEvens, "新数据");
        })
        .catch((err) => {});
    },

    goPrev() {
      this.headDate = this.ceDateRange(this.headDate, -1);
      this.dispatchEvent();
      this.fetchEventsList();
    },
    goNext() {
      this.headDate = this.ceDateRange(this.headDate, 1);
      this.dispatchEvent();
      this.fetchEventsList();
    },
    ceDateRange(date, num) {
      let dt = new Date(date);
      return new Date(dt.setMonth(dt.getMonth() + num));
    },
    dispatchEvent() {
      this.title = dateFunc.format(
        this.headDate,
        this.titleFormat,
        this.monthNames
      );
      let startDate = dateFunc.getStartDate(this.headDate);
      let curWeekDay = startDate.getDay();
      let diff = parseInt(this.firstDay) - curWeekDay;
      if (diff) diff -= 7;
      startDate.setDate(startDate.getDate() + diff);
      let endDate = dateFunc.changeDay(startDate, 41);
      let currentDate = dateFunc.getStartDate(this.headDate);
    },
    // 显示隐藏
    switchChang(e) {
      console.log(e, "点击的switch的值");
      this.switchVal = e;
    },
  },
};
</script>
<style scoped lang="scss">
.monthlist {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  padding: 0 20px;
  background-color: var(--color-theme);

  .navlef {
    width: 19%;
  }
  .comp-full-calendardiy {
    width: 100%;
    height: 100%;
    margin: 0 2%;
    margin: 0 auto;
    .month-title {
      padding-top: 50px;
    }
    .title {
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      height: 40px;
      > :first-child {
        i {
          font-size: 22px;
          margin-right: 10px;
        }
        span {
          font-size: 24px;
          font-weight: bold;
        }
      }
      > :last-child {
        display: flex;
        align-items: center;
        span {
          font-size: 18px;
          color: gray;
          margin-left: 10px;
        }
      }
    }
    .time {
      line-height: 30px;
      font-size: 20px;
      font-weight: bold;
      text-align: center;
    }
    .header-center {
      position: relative;
      height: 80%;
      .btn {
        position: absolute;
        z-index: 100;
        height: 36px;
        width: 36px;
        line-height: 36px;
        cursor: pointer;
        transition: 0.3s;
        border-radius: 50%;
        background-color: rgba(31, 45, 61, 0.11);
        color: #fff;
        text-align: center;
      }
      .up {
        left: 25px;
        top: 50%;
      }
      .down {
        right: 25px;
        top: 50%;
      }
    }
  }
}
</style>
